import { defineStore } from "pinia";
import { getCurrentInvoice, setCurrentInvoice } from "@/utils/storage";

export const useOutletStore = defineStore("outlet", {
  state: () => ({
    outlet: null,
    showPaymentOptionDialog: false,
    order: false,
    orderList: [],
    editId: "",
    currentInvoice: getCurrentInvoice() || "",
    firebaseToken: "",
    showProductDetail: false,
    showCartModal: false,
  }),
  actions: {
    setShowCartModal(value) {
      this.showCartModal = value;
    },
    setShowProductDetail(value) {
      this.showProductDetail = value;
    },
    setFirebaseToken(token) {
      this.firebaseToken = token;
    },
    setStore(outlet) {
      this.outlet = outlet;
    },
    setshowPaymentOptionDialog(value) {
      this.showPaymentOptionDialog = value;
    },
    setOrder(value) {
      this.order = value;
    },
    setOrderList(value) {
      this.orderList = value;
    },
    setEditId(value) {
      this.editId = value;
    },
setCurrentInvoice(value) {
      this.currentInvoice = value;
      if (value) {
        setCurrentInvoice(value);
      }
    },
  },
});
